const TickIcon = () => {
  return (
    <svg data-testid="tick-icon" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 1L2.875 5.125L1 3.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default TickIcon